import { Routes } from "@angular/router";
import { FullLayoutComponent } from "./features/full-layout/full-layout.component";
import { SimpleLayoutComponent } from "./features/simple-layout/simple-layout.component";
import { requireLogin } from "../../../libs/services/src/lib/auth/auth.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
    canActivateChild: [requireLogin()],
    children: [
      {
        path: "dashboard",
        data: { title: "Dashboard" },
        loadComponent: () => import("./pages/dashboard/dashboard.component").then((m) => m.DashboardComponent),
      },
      {
        path: "projects",
        loadChildren: () => import("./pages/projects/projects.routes").then((m) => m.PROJECT_ROUTES),
      },
      {
        path: "users",
        loadChildren: () => import("./pages/users/users.routes").then((m) => m.USERS_ROUTES),
      },
      // {
      //   path: "groups",
      //   loadChildren: () => import("./pages/groups/groups.routes").then((m) => m.GROUPS_ROUTES),
      // },
      // {
      //   path: "templates",
      //   loadChildren: () => import("./pages/templates/templates.routes").then((m) => m.TEMPLATES_ROUTES),
      // },
      {
        path: "orders",
        loadChildren: () => import("./pages/orders/orders.routes").then((m) => m.ORDER_ROUTES),
      },
      {
        path: "drafts",
        loadChildren: () => import("./pages/drafts/drafts.routes").then((m) => m.DRAFTS_ROUTES),
      },
      {
        path: "builder",
        loadChildren: () => import("./pages/builder/builder.routes").then((m) => m.BUILDER_ROUTES),
      },
      {
        path: "quotes",
        loadChildren: () => import("./pages/quotes/quotes.routes").then((m) => m.QUOTES_ROUTES),
      },
      {
        path: "tools",
        loadChildren: () => import("./pages/tools/tools.routes").then((m) => m.TOOLS_ROUTES),
      },
      // {
      //   path: "settings",
      //   loadChildren: () => import("./pages/settings/settings.routes").then((m) => m.SETTINGS_ROUTES),
      // },
    ],
  },
  {
    path: "",
    component: SimpleLayoutComponent,
    data: {
      title: "Login",
    },
    children: [
      {
        path: "login",
        loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
      },
    ],
  },
];

